import React from 'react'
import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
} from '@material-ui/core'
import { KeyboardArrowRight, MoreVert } from '@material-ui/icons'
import { DeleteDialog } from 'components/Dialog/DeleteDialog'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { advancedFilterList } from 'components/Filter/AdvancedFilter'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { amtNumStr, amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import { useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory, useParams } from 'react-router'
import {
  AcctPermission,
  useDeleteFaProvisionImpairmentReversalMutation,
  useGetDocNumTitleQuery,
} from 'generated/graphql'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'

export const ProvisionImpairmentReversalEntryList = (props: any) => {
  const {
    filteredList,
    listLoading,
    listStatus,
    fetchMore,
    hasMore,
    setOriginalListing,
  } = props

  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  let history = useHistory()
  const { CompanyID }: any = useParams()

  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const [deleteAA, setDeleteAA] = useState<boolean>(false)
  const { setOpenSnackBar, setSnackBarMsg }: any = React.useContext(
    SnackBarContext
  )
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const {
    loading: docNumHeaderLoading,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      RefTable: 'fa_provision_impairment_reversal',
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const docNumChecker = getDocumentNumberHeader?.length === 0

  const [
    deleteReversal,
    { loading: deleteLoading },
  ] = useDeleteFaProvisionImpairmentReversalMutation({
    onError: ({ message }) => {
      const error = message?.substring(15)
      setErrMsg(error)
      setErrorDia(true)
    },
    onCompleted: () => {
      setDeleteAA(false)
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.deleteRecord())
      const updatedList = filteredList.filter(
        (item: any) => item.provision_impairment_reversal_id !== menu?.ID
      )
      setOriginalListing(updatedList)
    },
  })

  const handleDelete = (id: string) => {
    deleteReversal({
      variables: {
        provision_impairment_reversal_id: id,
      },
    })
  }
  const { handlePermDisabled } = usePermissionChecker()

  return (
    <>
      {(listLoading || deleteLoading || docNumHeaderLoading) && <Loading />}

      <ContentWrapper advSearch float>
        <List className="core-list">
          {advancedFilterList(filteredList) === undefined ||
          advancedFilterList(filteredList).length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length
                fetchMore({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr: [listStatus],
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name === '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                  },
                })
              }}
              hasMore={hasMore}
              className=""
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {advancedFilterList(filteredList)?.map((el, index) => {
                return (
                  <ListItem>
                    <ListItemText
                      primary={
                        <>
                          <span className="desc date-width">
                            {`${formatDate(el?.reversal_date)}` || 'N/A'}
                          </span>
                          <span className="xsTitle flex-space">
                            {el?.DocNo}
                          </span>
                          <span className={`xsTitle`}>{el?.Asset?.name}</span>
                        </>
                      }
                      secondary={
                        <>
                          <Grid container>
                            <Grid
                              spacing={1}
                              container
                              className="table-content"
                            >
                              <Grid item xs={6}>
                                <span className="desc flex-space">
                                  {el?.Asset?.Category?.name}
                                </span>
                              </Grid>
                              <Grid item xs={6} style={{ textAlign: 'right' }}>
                                <span className="desc flex-space">
                                  {'Acc. Impairment '}
                                  <span
                                    style={{
                                      textDecoration: 'line-through',
                                    }}
                                  >
                                    {amtStr(el?.accumulated_impairment)}
                                  </span>
                                  <span> → </span>
                                  <span style={{ color: 'orange' }}>
                                    {amtStr(
                                      el?.accumulated_impairment_reversal
                                    )}
                                  </span>
                                </span>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid container>
                            <Grid
                              spacing={1}
                              container
                              className="table-content"
                            >
                              <Grid item xs={12}>
                                <span className="desc">{el?.description}</span>
                              </Grid>
                            </Grid>
                          </Grid>
                        </>
                      }
                    />
                    <ListItemSecondaryAction>
                      {listStatus === 'ACTIVE' || listStatus === 'REJECTED' ? (
                        <>
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            aria-controls="menu-list"
                            aria-haspopup
                            onClick={e =>
                              handleClick(
                                e,
                                el?.provision_impairment_reversal_id,
                                index,
                                el
                              )
                            }
                          >
                            <MoreVert />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton edge="end" aria-label="arrow">
                          <KeyboardArrowRight
                            onClick={() =>
                              history.push({
                                pathname: `/fixed-assets/${CompanyID}/assets-change/provision-for-impairment-reversal/${el?.provision_impairment_reversal_id}/detail`,
                                state: el,
                              })
                            }
                          />
                        </IconButton>
                      )}
                    </ListItemSecondaryAction>
                  </ListItem>
                )
              })}
            </InfiniteScroll>
          )}
        </List>
        {listStatus === 'ACTIVE' && (
          <FloatButton
            onClick={() => {
              if (docNumChecker) {
                setOpenSnackBar(true)
                setSnackBarMsg(SystemMsgs.errorNumberingStructure())
              } else {
                history.push(
                  `/fixed-assets/${CompanyID}/assets-change/provision-for-impairment-reversal/add`
                )
              }
            }}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum:
                AcctPermission.FixedAssetsProvisionImpairmentReversalCreate,
            })}
          />
        )}
      </ContentWrapper>

      {listStatus === 'ACTIVE' ? (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem
            onClick={() => {
              history.push({
                pathname: `/fixed-assets/${CompanyID}/assets-change/provision-for-impairment-reversal/${menu?.obj?.provision_impairment_reversal_id}/edit`,
                state: menu?.obj,
              })
            }}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum:
                AcctPermission.FixedAssetsProvisionImpairmentReversalUpdate,
            })}
          >
            <span>Edit</span>
          </MenuItem>
          <MenuItem
            onClick={() => setDeleteAA(true)}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum:
                AcctPermission.FixedAssetsProvisionImpairmentReversalDelete,
            })}
          >
            <span>Delete</span>
          </MenuItem>
        </Menu>
      ) : (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem
            onClick={() => {
              history.push({
                pathname: `/fixed-assets/${CompanyID}/assets-change/provision-for-impairment-reversal/${menu?.obj?.provision_impairment_reversal_id}/edit`,
                state: { ...menu?.obj, mode: 'resubmit' },
              })
            }}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum:
                AcctPermission.FixedAssetsProvisionImpairmentReversalUpdate,
            })}
          >
            <span>Resubmit</span>
          </MenuItem>
        </Menu>
      )}

      <DeleteDialog
        ID={menu?.ID}
        openDeleteDialog={deleteAA}
        setOpenDeleteDialog={setDeleteAA}
        title={'Provision for Impairment Reversal'}
        menu={menu?.obj}
        passID={menu?.ID}
        handleDelete={handleDelete}
      />

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={
          'You cannot delete this entry because it is already in use.'
        }
      />
    </>
  )
}
